import { AssistentItem } from './assistent_config';
import { DataService } from '../../../services/data_service';
import { getAssistentConfigEingangsHinweise } from './items/assistent_config_hinweise';
import { getAssistentConfigKonfig } from './items/assistent_config_config';
import { getAssistentConfigStandorte } from './items/assistent_config_standorte';
import { getAssistentConfigStrom } from './items/assistent_config_strom';
import { getAssistentConfigUnternehmen } from './items/assistent_config_unternehmensdaten';
import { getAssistentConfigWaerme } from './items/assistent_config_waerme';
import { IDs } from '../../../helpers/IDs';
import { isEnableStandorte, isEnableEnergiesteuerrueckerstattung } from './assistent_helpers';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { isProduzierendesGewerbe } from '../../../main/functions/getGewerk';

export function getAssistentConfigSteuer(
    standort: any, data: any, jahr: number, dataService: DataService, triggerService: TriggerService,
    onRoutingChange: (routing: any) => void, clearPruefState: () => void, isAdmin: boolean, bereichKey: string, routing: any
) {
    const konfiguration: any[] = (data || {})[IDs.ENT_KONFIGURATION] || [];
    const enableStandorte: boolean = isEnableStandorte(konfiguration);
    const enableEnergiesteuerrueckerstattung: boolean = isEnableEnergiesteuerrueckerstattung(konfiguration);
    const config: AssistentItem[] = [];

    // 1. Allgemeine Unternehmensangaben
    config.push(getAssistentConfigKonfig(data, onRoutingChange, isAdmin, bereichKey, { gliederung: '1.1' }));
    config.push(getAssistentConfigUnternehmen(data, triggerService, { gliederung: '1.2' }));
    if (enableStandorte) {
        config.push(getAssistentConfigStandorte(data, dataService, triggerService, { gliederung: '1.3' }));
    }

    // 2. Datenerfassung
    const isProduGewebe: boolean = isProduzierendesGewerbe(data);
    config.push(getAssistentConfigEingangsHinweise(data));
    if (isProduGewebe) {
        config.push(getAssistentConfigStrom(standort, data, jahr, triggerService));
        if (enableEnergiesteuerrueckerstattung) {
            config.push(getAssistentConfigWaerme(standort, data, jahr, triggerService));
        }
    }

    return config;
}
